import styled from 'styled-components';

import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { Banner } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { NegativeBadge } from 'ui/badge';

import { selectUserProject } from 'core/userContext/selectors';
import { UserContextProject } from 'core/userContext';
import { SecondaryButton } from 'ui/button';
import { spacing } from 'ui/theme';
import { getUrlParams } from 'utils/urlParams';

import { changeUserAndProject } from '../actions';

const StyledBanner = styled(Banner)`
  margin-top: ${spacing.half};
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButtonWrapper = styled.span`
  margin-left: ${spacing.half};
`;

export const BossError = () => {
  const { id, name } = useSelector(selectUserProject) as UserContextProject;
  const dispatch = useDispatch();
  const { search } = useLocation();
  const { originalPath, bossUserEmail, bossProjectId, bossProjectName } = getUrlParams(search);
  const decodedPath = decodeURI(originalPath);
  const { projectId } = getUrlParams(decodedPath);
  const decodedPathNoProject = decodedPath
    .replace(`projectId=${projectId}&`, '')
    .replace(`projectId=${projectId}`, '');
  return (
    <div>
      <Banner variant={BannerVariants.WARNING}>
        Invalid or unauthorized ID for Project: {id} - {name}
      </Banner>
      <StyledBanner variant={BannerVariants.INFO}>
        <BannerContent>
          <NegativeBadge>BOSS-Shortcut</NegativeBadge>
          <StyledButtonWrapper>
            <SecondaryButton
              onClick={() => {
                dispatch(
                  changeUserAndProject(
                    { userEmail: bossUserEmail, projectId: bossProjectId },
                    () => {
                      window.location.assign(decodedPathNoProject);
                    },
                  ),
                );
              }}
            >
              View as {bossUserEmail} - Project: {bossProjectId} - {bossProjectName}
            </SecondaryButton>
          </StyledButtonWrapper>
        </BannerContent>
      </StyledBanner>
    </div>
  );
};

export default BossError;
